import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';

export interface IIsWorkbookServerRefreshableResult extends IResult {
  refreshable: boolean;
}

export class IIsWorkbookServerRefreshableRequest extends Request<ISingleIdParams, IIsWorkbookServerRefreshableResult> {
  constructor(params: ISingleIdParams) {
    super('isWorkbookServerRefreshable', params);
  }
}
